// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"n2-z"};